// component
import { IconComponent } from '@centria-ui-atoms/icon-component'
import { Typography } from '@centria-ui-atoms/typography'
import { Button } from '@centria-ui-atoms/button'

// prime components
import { confirmDialog as PrconfirmDialog } from 'primereact/confirmdialog'

// Styles
import classes from './styles.module.scss'

// type
import type { ConfirmDialogProps as PrConfirmDialogProps } from 'primereact/confirmdialog'
import type { IconName } from '@centria-ui-atoms/icon-component'

export interface ConfirmDialogProps extends PrConfirmDialogProps {
  caption?: string
  iconName?: IconName
}

export const ConfirmDialog = ({
  header,
  message,
  caption,
  iconName,
  ...props
}: ConfirmDialogProps) =>
  PrconfirmDialog({
    closable: false,
    draggable: false,
    className: classes.dialog,
    headerClassName: classes.dialog_header,
    contentClassName: classes.dialog_content,
    icon: iconName && (
      <IconComponent size='lg' color='danger' icon={iconName} />
    ),
    message: (
      <>
        <Typography fontSize='label'>{message as string}</Typography>
        {caption && (
          <Typography className='mt-2' fontSize='minimum'>
            {caption}
          </Typography>
        )}
      </>
    ),
    header: (
      <Typography fontcolor='primary' fontWeight='bold' fontSize='title'>
        {header as string}
      </Typography>
    ),
    footer: (ev) => (
      <>
        <Button variant='light' onClick={ev.reject}>
          {ev.rejectLabel}
        </Button>
        <Button variant='secondary' onClick={ev.accept}>
          {ev.acceptLabel}
        </Button>
      </>
    ),
    ...props
  })
